export default "/assets/images/icon-love.5f607ec28070ba2f.svg";